<template>
  <!-- 业务员审核 -->
  <div class="salesmanAudit">
    <!-- 面包屑导航 -->
    <crumbs-bar
      @refresh="handleRefresh"
      :crumbsList="['业务员管理', $route.meta.title]"
    >
      <template slot="controls">
        <el-button type="danger" icon="el-icon-delete" @click="getDelete"
          >批量删除</el-button
        >
      </template>
    </crumbs-bar>
    <!-- 搜索框 -->
    <search-bar>
      <template>
        <label class="label">状态：</label>
        <el-select
          v-model="searchForm.Audit"
          style="width: 100px; margin-right: 5px"
        >
          <el-option value="0,1,2" label="全部"></el-option>
          <el-option value="1" label="未审核"></el-option>
          <el-option value="2" label="已审核"></el-option>
        </el-select>
        <el-input
          style="width: 200px; margin-right: 5px"
          clearable
          placeholder="输入单位/登录名/姓名/电话"
          v-model="searchForm.name"
        ></el-input>
        <el-button type="primary" icon="el-icon-search" @click="seach"
          >搜索</el-button
        >
      </template>
    </search-bar>
    <!-- 数据展示 -->
    <el-table
      :data="tableData"
      stripe
      border
      height="calc(100% - 130px)"
      tooltip-effect="dark"
      style="width: 100%"
      ref="handSelectTest"
      @selection-change="selectionChange"
    >
      <el-table-column
        type="selection"
        align="center"
        width="55"
        :selectable="selectable"
      >
      </el-table-column>
      <el-table-column label="序号" align="center" width="50">
        <template slot-scope="scope">
          <span>{{ (currPage - 1) * pageSize + scope.$index + 1 }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="entname"
        label="所属机构"
        align="center"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="username"
        label="用户名"
        align="center"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="name"
        label="真实姓名"
        align="center"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="telphone"
        label="手机号"
        align="center"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="add_time"
        label="创建日期"
        align="center"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="businessname"
        label="所属厂家"
        align="center"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="status"
        label="状态"
        align="center"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          <el-tag type="warning" plain v-if="scope.row.status == '1'"
            >未审核</el-tag
          >
          <el-tag type="primary" plain v-if="scope.row.status == '2'"
            >已审核</el-tag
          >
        </template>
      </el-table-column>
      <el-table-column label="操作" align="center">
        <template slot-scope="scope">
          <el-button
            type="primary"
            style="padding: 2px 3px"
            plain
            @click="getExamine(scope.row)"
            v-show="scope.row.status == '1'"
            >审核</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页 -->
    <pagination
      :allPage="allPage"
      :pageSize="pageSize"
      :currIndex="currPage"
      @hanSiChange="hanSiChange"
      @hanCurrChange="hanCurrChange"
    ></pagination>
    <!-- <el-dialog :title="审核弹窗" :visible.sync="carrierstate" width='37%' v-dialogDrag :close-on-click-modal="false">
		</el-dialog> -->
  </div>
</template>

<script>
export default {
  name: "salesmanAudit",
  data() {
    return {
      /**表格数据 */
      //序号	单位	用户名	真实姓名	手机号	创建日期	状态	操作
      tableData: [],
      /**分页数据 */
      currPage: 1,
      pageSize: 20,
      allPage: 0,
      /**搜索表单 */
      searchForm: {
        name: "",
        Audit: "1",
      },
      userids: [],
    };
  },
  created() {
    this.seach();
  },
  methods: {
    seach() {
      this.getTableData(1);
    },
    /**获取数据 */
    getTableData(num) {
      this.currPage = num == 1 ? 1 : this.currPage;
      let data = {
        EntId: window.localStorage.getItem("entId"),
        Audit: this.searchForm.Audit,
        SouStr: this.searchForm.name,
        PageIndex: this.currPage,
        PageSize: this.pageSize,
      };
      this.$request({
        url: "Users/GetSalesmanList",
        method: "post",
        data: data,
      })
        .then((res) => {
          if (res.success) {
            this.tableData = res.data;
            this.allPage = res.total;
          } else {
            //失败提示
            this.$message({
              message: res.message,
              type: "error",
            });
            this.allPage = 0;
          }
        })
        .catch((err) => {
          window.console.log(err);
          this.allPage = 0;
        });
    },
    /**分页size改变 */
    hanSiChange(val) {
      this.pageSize = val;
      this.getTableData();
    },
    /**当前页改变 */
    hanCurrChange(val) {
      this.currPage = val;
      this.getTableData();
    },
    /**刷新表格数据 */
    handleRefresh() {
      this.getTableData();
    },
    //审核
    getExamine(list) {
      this.$confirm("是否审核此数据?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        let data = {
          userid: list.userid,
          entid: list.entid,
        };
        this.$request({
          url: "Users/AuditSalesman",
          method: "post",
          data: data,
        })
          .then((res) => {
            if (res.success) {
              this.$message({
                message: res.message,
                type: "success",
              });
              this.getTableData();
            } else {
              this.$message({
                message: res.message,
                type: "error",
              });
            }
          })
          .catch((err) => {
            window.console.log(err);
          });
      });
    },
    //判断禁止选择
    selectable(row) {
      if (row.status == "1") {
        return true;
      }
      return false;
    },
    /**selection change触发事件 */
    selectionChange(section) {
      // this.userids
      for (var i = 0; i < section.length; i++) {
        this.userids.push(section[i].userid);
      }
      console.log(this.userids);
    },
    //删除
    getDelete() {
      if (this.userids.length == 0) {
        this.$message({
          message: "请先勾选需要删除的数据！",
          type: "warning",
        });
        return;
      }
      this.$confirm("是否删除勾选数据?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          let data = {
            userids: this.userids,
          };
          this.$request({
            url: "Users/BatchDeleteSalesman",
            method: "post",
            data: data,
            headers: {
              Auth: window.localStorage.getItem("Token"),
            },
          })
            .then((res) => {
              if (res.success) {
                this.$message({
                  message: res.message,
                  type: "success",
                });
                this.$refs.handSelectTest.clearSelection();
                this.getTableData();
              } else {
                //失败提示
                this.$message({
                  message: res.message,
                  type: "error",
                });
              }
            })
            .catch((err) => {
              window.console.log(err);
            });
        })
        .catch(() => {
          this.$message.info("取消制作");
        });
    },

    /**绑定分组 */
    handleBind(row) {
      let prams = null;
      if (row) {
        prams = encodeURIComponent(JSON.stringify(row));
      } else {
        prams = row;
      }
      this.$router.push({
        path: "bindGroup",
        query: {
          row: prams,
        },
      });
      prams = null;
    },
  },
};
</script>

<style scoped>
.salesmanAudit {
  width: 100%;
  height: 100%;
}
</style>
